export function langUrlChange() {
  if (document.querySelectorAll('.js-langChange')) {
    const langChangeAll = document.querySelectorAll('.js-langChange');

    langChangeAll.forEach((target) => {
      target.addEventListener('change', () => {
        const uri = new URL(window.location.href);
        const thisProtocol = uri.protocol;
        const thisDomain = uri.host;
        const selectUrl = target.value;
        const createUrl = thisProtocol + '//' + thisDomain + '/' + selectUrl;

        window.location.href = createUrl;
      });
    });
  }
}
